import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import TRANSLATIONS_EN from 'translations/en_original.json';
import TRANSLATIONS_HI from 'translations/localeNew/hi.json';
import TRANSLATIONS_BN from 'translations/localeNew/bn_IN.json';
import TRANSLATIONS_GJ from 'translations/localeNew/gu_IN.json';
import TRANSLATIONS_KN from 'translations/localeNew/kn.json';
import TRANSLATIONS_ML from 'translations/localeNew/ml.json';
import TRANSLATIONS_MR from 'translations/localeNew/mr.json';
import TRANSLATIONS_TE from 'translations/localeNew/te.json';
import TRANSLATIONS_TA from 'translations/localeNew/ta_IN.json';

import { loadState } from 'utils/LocalStorage';
import { LANGUAGE } from 'utils/CONSTANT';
import { ILanguage } from 'types';

const selectedLanguage: ILanguage = loadState(LANGUAGE) as ILanguage;

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: TRANSLATIONS_EN },
			hi: { translation: TRANSLATIONS_HI },
			bn: { translation: TRANSLATIONS_BN },
			gu: { translation: TRANSLATIONS_GJ },
			kn: { translation: TRANSLATIONS_KN },
			ml: { translation: TRANSLATIONS_ML },
			mr: { translation: TRANSLATIONS_MR },
			te: { translation: TRANSLATIONS_TE },
			ta: { translation: TRANSLATIONS_TA },
		},
		fallbackLng: 'en',
	});

i18n.changeLanguage(selectedLanguage);

export default i18n;
